<script lang="ts">
  import { Col } from "sveltestrap";
  import Card from "../UiCommenCard.svelte";
  import VerifyingContentModal from "./VerifyingContentModal.svelte";
</script>
<Col sm='12'>
  <Card headerTitle="Verifying Modal Content">
      <div slot="contentbody">
          <div class="btn-showcase">
              <VerifyingContentModal content="@mdo" />
              <VerifyingContentModal content="@fat" />
              <VerifyingContentModal content="@getbootstrap" />
          </div>
      </div>
  </Card>
</Col>